import { LitElement, html, css } from "lit-element";
import {LayoutFlex} from "@stofloos/globals/styles/layout-flex";
import moment from "moment";

// language=CSS
export const InputTimeStyle = css`
	:host {
		position: relative;
		font-size: var(--input-time-font-size, 20px);

		user-select: none; /* supported by Chrome and Opera */
		-webkit-user-select: none; /* Safari */
		-khtml-user-select: none; /* Konqueror HTML */
		-moz-user-select: none; /* Firefox */
		-ms-user-select: none; /* Internet Explorer/Edge */
	}
	
	hidden {
		display: none;
	}
	
	.time-step {
		min-width: 25%;
		text-align: center;
	}
	
	.time-step-inner {
		margin: auto;
		border-radius: 50%;
		cursor: pointer;
		width: 32px;
		height: 32px;
		font-size:16px;
		line-height: 32px;
	}
	
	.time-step-inner:hover {
		background-color: var(--app-accent);
		color: #FFF;
	}
	
	timepicker-panel {
		margin: 0 -10px;
	}
	
	.timepicker-label {
		cursor: pointer;
		text-align: center;
		min-width: var(--input-time-label-width, 40px);
		min-height: var(--input-time-label-width, 40px);
		line-height: var(--input-time-label-width, 40px);
		margin: 5px 10px;
		
		padding: var(--input-time-padding, 5px);
		
		border-radius: var(--input-time-border-radius, 8px);
		border: 1px solid var(--input-time-border-color, var(--app-accent-light, #7f7f7f));
	}

	.input-control {
		cursor: pointer;
		min-height: 20px;
	}
	
	.input-control sw-icon {
		line-height: 20px;
	}
	
	.timepicker-minutes,
	.timepicker-hours {
		min-width: 140px;
	}
`;
const fillArray = (value, len)=> {
	if (len == 0) return [];
	let a = [value];
	while (a.length * 2 <= len) a = a.concat(a);
	if (a.length < len) a = a.concat(a.slice(0, len - a.length));
	return a;
}

export class InputTime extends LitElement {
	static get properties() {
		return {
			name: { type: String },

			value: { type: String },
			valueFormat: { type: String },

			label: { type: String },
			required: { type: Boolean },
			readonly: { type: Boolean },
			disabled: { type: Boolean },

			hourSteps: { type: Number },

			minHours: { type: Number },
			maxHours: { type: Number },

			minMinutes: { type: Number },
			maxMinutes: { type: Number },

			minTime: { type: String },
			maxTime: { type: String },


			showHoursPanel: { type: Boolean },
			showMinutesPanel: { type: Boolean },
			hidden: { type: Boolean }
		};
	}

	static get styles() {
		return [LayoutFlex, InputTimeStyle];
	}

	constructor() {
		super();
		this.showHoursPanel = false;
		this.showMinutesPanel = false;

		this.hourStep = 1;
		this.minHours = 6;
		this.maxHours = 22;

		this.minuteStep = 15;
		this.minMinutes = 0;
		this.maxMinutes = 0;

	}

	updated(_changedProperties) {
		if(_changedProperties.has('value') ||
			_changedProperties.has('minMinutes') ||
			_changedProperties.has('minHours' ||
			_changedProperties.has('maxMinutes') ||
			_changedProperties.has('maxHours'))) {
				if(this.value && this.valueFormat) {
					this.date = moment(this.value, this.valueFormat).set({second:0});

					this.minTime = moment(this.value, this.valueFormat).startOf('day');
					this.maxTime = moment(this.value, this.valueFormat).endOf('day');
				} else if (this.value) {
					this.date = moment(this.value).set({second:0});

					this.minTime = moment(this.value).startOf('day');
					this.maxTime = moment(this.value).endOf('day');
				} else{
					this.date = moment(this.value).set({second:0});
				}

				this.maxTime = moment(this.maxTime).hours(this.maxHours).minutes(this.maxMinutes);
				this.minTime = moment(this.maxTime).hours(this.minHours).minutes(this.minMinutes);
			}

	}

	onChange () {
		let event = new CustomEvent("sw-input-time:changed", {
			detail: { date: this.date.format('HH:mm:ss'), name: this.name },
			bubbles: true,
			composed: true
		});
		this.dispatchEvent(event);
	}

	render() {
		const hourArray = fillArray('', (this.maxHours-this.minHours) / this.hourStep);
		return html`
			<input type="time"
					value="${this.date ? this.date.format('HH:mm:ss') : ""}"
					name="${this.name}"
					placeholder="${this.label ? this.label : ""}"
					hidden
					?required="${this.required}"
					?disabled="${this.disabled}" />
					
			<div class="timepicker-panel layout horizontal center-center" ?hidden="${this.showHoursPanel || this.showMinutesPanel}">
				<div class="layout vertical center-center">
					<span @click="${()=>this.increment('hours')}" class="input-control input-increment"><sw-icon icon="chevron-up"></sw-icon></span>
					<strong class="timepicker-label" @click="${this.showHours}">${this.date ? this.date.format('HH') : "00"}</strong>
					<span @click="${()=>this.decrement('hours')}"  class="input-control input-decrement"><sw-icon icon="chevron-down"></sw-icon></span>
				</div>
				<div class="layout vertical center-center">
					<strong @click="${this.showMinutes}">:</strong>
				</div>
				<div class="layout vertical center-center">
					<span @click="${()=>this.increment('minutes')}"  class="input-control input-increment"><sw-icon icon="chevron-up"></sw-icon></span>
					<strong class="timepicker-label"  @click="${this.showMinutes}">${this.date ? this.date.format('mm') : "00"}</strong>
					<span @click="${()=>this.decrement('minutes')}"  class="input-control input-decrement"><sw-icon icon="chevron-down"></sw-icon></span>
				</div>
			</div>
			<div class="timepicker-hours layout horizontal wrap" ?hidden="${!this.showHoursPanel}">
				${hourArray.map((item ,index) => {
					return  html`<div  @click="${() => this.setHour((index+this.minHours))}"  class="time-step"><div class="time-step-inner">${(index*this.hourStep)+this.minHours}</div></div>`
				})}
			</div>
			<div class="timepicker-minutes layout horizontal wrap" ?hidden="${!this.showMinutesPanel}">
				${Array((60 / this.minuteStep)).fill().map((item ,index) => {
					return  html`<div  @click="${() => this.setMinute(index)}"  class="time-step"><div class="time-step-inner">${index*this.minuteStep}</div></div>`
				})}
			</div>
			
			
		`;
	}

	increment(type) {
		if(this.readonly) {
			return;
		}

		let amount;
		if(type === 'minutes') {
			amount = this.minuteStep;
		}
		if(type === 'hours') {
			amount = this.hourStep;
		}
		const temp = moment(this.date).add(amount, type);
		if(temp < this.maxTime) {
			// Keeps day on the default starting day
			const defaultDate = moment(this.value);
			this.date.add(amount, type).date(defaultDate.date());
			this.requestUpdate();
			this.onChange();
		}
	}

	decrement(type) {
		if(this.readonly) {
			return;
		}

		let amount;
		if(type === 'minutes') {
			amount = this.minuteStep;
		}
		if(type === 'hours') {
			amount = this.hourStep;
		}

		const temp = moment(this.date).subtract(amount, type);
		if(temp >= this.minTime) {
			// Keeps day on the default starting day
			const defaultDate = moment(this.value);
			this.date.subtract(amount, type).date(defaultDate.date());
			this.requestUpdate();
			this.onChange();
		}
	}

	setHour(index) {
		const hour = index * this.hourStep;
		this.date.hours(hour);
		this.showHoursPanel = false;
		this.requestUpdate();
		this.onChange();

	}

	setMinute(index) {
		const minute = index * this.minuteStep;
		this.date.minutes(minute);
		this.showMinutesPanel = false;
		this.requestUpdate();
		this.onChange();
	}

	showHours() {
		if(this.readonly) {
			return;
		}

		this.showHoursPanel = true;
	}

	showMinutes() {
		if(this.readonly) {
			return;
		}

		this.showMinutesPanel = true;
	}
}

customElements.define("input-time", InputTime);
